import {
    PharmacyData
} from 'one-state-patient-pharmacy/src/PharmacyData';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * patient Pharmacies Component
 * @param response  has the backend pharmacy response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    const { log } = context;
    /**
     * @param result contains the transformed response
     */
    let pdata: PharmacyData[] = [];

    let result :any = {
        pdata:pdata,
        error:undefined

    }
    if (response && (response.status >= 400 || response.type == "error")) {
       result.error=response;
    }
    else if (response && response.length > 0) {
        response.forEach((resdata: any) => {
            if (resdata.Pharmacies) {
                resdata.Pharmacies.forEach((pharmdata: any) => {
                    let pharmacyobject:PharmacyData ={
                        pharmacyname:"",
                        pharmacynumber:"",
                        pharmacyaddress: "",
                    }
                    const { Name, Phone, PharmacyAddress } = pharmdata;

                    pharmacyobject.pharmacyname =  Name || "";
                    pharmacyobject.pharmacynumber = Phone || "";

                    if (PharmacyAddress) {
                        let addressInfo = [PharmacyAddress.City, PharmacyAddress.State, PharmacyAddress.Zip];
                        if (Array.isArray(PharmacyAddress.Street)) {
                            addressInfo = [PharmacyAddress.Street[0]].concat(addressInfo);
                        }
                        pharmacyobject.pharmacyaddress = addressInfo.join(', ');
                    } else {
                        pharmacyobject.pharmacyaddress = "";
                    }

                    pdata.push(pharmacyobject)
                })
            }
        })
    }
    log.debug(
        "ccw-gadget,pharmacy-cerner",
        "pharmacy-cerner transforamtion response ", {
        pdata
    });
    result.pdata=pdata
    return result;
}